import { sdk } from 'src/utilities/sdk';
import { ILocation } from 'src/types/Location';

export interface AddNewLocationProps {
  corpId: string;
  newLocation: Partial<ILocation>;
}

export interface UpdateLocationProps {
  corpId: string;
  locationId: string;
  updatedLocation: Partial<ILocation>;
}

export const addNewLocation = async ({
  corpId,
  newLocation,
}: AddNewLocationProps): Promise<{ id: string }> => {
  return sdk.http.post(`/corp-admin/${corpId}/locations`, newLocation);
};

export const updateLocation = async ({
  corpId,
  locationId,
  updatedLocation,
}: UpdateLocationProps): Promise<void> => {
  await sdk.http.put(
    `/corp-admin/${corpId}/locations/${locationId}`,
    updatedLocation
  );
};
